<template>
  <v-card
    class="ma-3"
    flat
  >
    <Breadcrumbs
      :paths="['/editor']"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.editor.content_open.title") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="pa-5 mt-1">
      <p class="mb-5">
        {{ $t("message.editor.content_open.open_document") }}
      </p>
      <!--
      <v-tabs
        background-color="primary"
        dark
        v-model="content_mode"
      >
        <v-tab href="#source">
          {{ $t("message.common.source") }}
        </v-tab>
        <v-tab href="#translated">
          {{ $t("message.common.translated") }}
        </v-tab>
        <template v-if="$store.getters.user.domain === 't-3mt'">
          <v-tab href="#corpus">
            {{ $t("message.common.corpus") }}
          </v-tab>
          <v-tab href="#term">
            {{ $t("message.common.term") }}
          </v-tab>
        </template>

        <v-tabs-items v-model="content_mode">
      -->
          <!-- content_mode[0]: source -->
      <!--
          <v-tab-item value="source">
            <v-card class="pa-5">
              <FileSelect
                ref="source_select"
                :nid="$store.getters.user.nid"
                :uid="$store.getters.user.uid"
                :selected_file="sources"
                file_type="source"
                extension_type="json"
                :own_only="true"
                :multiple="false"
                :select_one="true"
                :max_select="1"
                :show_select="false"
                initital_fid=""
                v-on:update_files_select="sources = $event; get_content()"
              ></FileSelect>
            </v-card>
          </v-tab-item>
      -->

          <!-- content_mode[1]: translated -->
      <!--
          <v-tab-item value="translated">
      -->
            <v-card class="pa-5">
              <FileSelect
                ref="translated_select"
                :nid="$store.getters.user.nid"
                :uid="$store.getters.user.uid"
                :selected_file="translateds"
                file_type="translated"
                extension_type="json"
                :own_only="true"
                :multiple="false"
                :select_one="true"
                :max_select="1"
                :show_select="false"
                initital_fid=""
                v-on:update_files_select="translateds = $event; get_content()"
                :operations="['download', 'preview']"
              ></FileSelect>
            </v-card>
      <!--
          </v-tab-item>

          <template v-if="$store.getters.user.domain === 't-3mt'">
      -->
            <!-- content_mode[2]: corpus -->
      <!--
            <v-tab-item value="corpus">
              <v-card class="pa-5">
                <CorpusSelect
                  ref="corpus_select"
                  :nid="$store.getters.user.nid"
                  :uid="$store.getters.user.uid"
                  :selected_corpus="corpuses"
                  extension_type="json"
                  :own_only="true"
                  :multiple="false"
                  :select_one="true"
                  :max_select="1"
                  :show_select="false"
                  initital_cid=""
                  v-on:update_corpuses_select="corpuses = $event; get_content()"
                ></CorpusSelect>
              </v-card>
            </v-tab-item>
      -->

            <!-- content_mode[3]: term -->
      <!--
            <v-tab-item value="term">
              <v-card class="pa-5">
                <TermSelect
                  ref="term_select"
                  :nid="$store.getters.user.nid"
                  :uid="$store.getters.user.uid"
                  :selected_term="terms"
                  extension_type="json"
                  :own_only="true"
                  :multiple="false"
                  :select_one="true"
                  :max_select="1"
                  :show_select="false"
                  initital_yid=""
                  v-on:update_terms_select="terms = $event; get_content()"
                ></TermSelect>
              </v-card>
            </v-tab-item>
          </template>
        </v-tabs-items>
      </v-tabs>
      -->
    </v-card>
  </v-card>
</template>
<script>
import Breadcrumbs from '../components/Breadcrumbs';
import FileSelect from '../components/FileSelect'
import CorpusSelect from '../components/CorpusSelect'
import TermSelect from '../components/TermSelect'
import { http_error } from "../js/http_error";
import { editor } from "../js/editor";

export default {
  name: 'ContentOpen',
  components: {
    Breadcrumbs,
    FileSelect,
    CorpusSelect,
    TermSelect
  },
  mixins: [http_error, editor],
  data: function(){
    return {
      module_id: "03",
      nav_path: null,
      content_mode: "translated",

      //// content_mode[0]: source
      sources: [],
      //// content_mode[1]: translated
      translateds: [],
      //// content_mode[2]: corpus
      corpuses: [],
      //// content_mode[3]: term
      terms: []
    };
  },
  mounted: function(){
    /*
    if(this.$route.query.mode){
      this.content_mode = this.$route.query.mode;
    }else{
      this.content_mode = this.$store.getters["editor/content_mode"];
    }
    */
  },
  methods: {
    get_content: function(){
      /*
      var xid = this.translateds[0].fid;
      this.$router.push("/editor/" + this.content_mode + "/" + xid);
      */
      var xid = "";
      switch(this.content_mode){
        case "source":
          xid = this.sources[0].fid;
          break;
        case "translated":
          xid = this.translateds[0].fid;
          break;
        case "corpus":
          xid = this.corpuses[0].cid;
          break;
        case "term":
          xid = this.terms[0].yid;
          break;
      }
      if(module !== "" && xid !== ""){
        this.$router.push("/editor/" + this.content_mode + "/" + xid + "?referer=" + encodeURIComponent("/editor?mode=" + this.content_mode) );
      }
    }
  }
}
</script>
